import { Badge, Modal, Table } from 'flowbite-react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGetMeetingRecordingByMeetingIdQuery } from 'src/hooks/meeting.hooks';
import { RecordingStatus, MeetingRecording } from 'types';
import { Loader } from 'ui';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	meetingId: string;
}

const MeetingRecordingModal = ({ isOpen, onClose, meetingId }: Props) => {
	const [recordings, setRecordings] = useState<MeetingRecording[]>([]);

	const { data, isLoading } = useGetMeetingRecordingByMeetingIdQuery(meetingId);

	useEffect(() => {
		if (data?.recordings) {
			setRecordings(data.recordings as MeetingRecording[]);
		}
	}, [data]);

	if (!meetingId) return null;
	if (isLoading) return <Loader />;

	return (
		<Modal dismissible={true} show={isOpen} size="5xl" popup={true} onClose={onClose}>
			<Modal.Header className="bg-gray-100 pl-3">Recordings</Modal.Header>
			<Modal.Body className="dark:bg-[#1F2A37]">
				<div className="pt-2 text-center">
					<div className="mb-8">
						{recordings.length === 0 ? (
							<div className="mx-6 flex flex-col items-center rounded-md bg-[#374151] px-4 py-2 text-base text-white">
								No recordings
							</div>
						) : (
							<Table hoverable>
								<Table.Head>
									<Table.HeadCell>Start Time</Table.HeadCell>
									<Table.HeadCell>End Time</Table.HeadCell>
									<Table.HeadCell>Status</Table.HeadCell>
									<Table.HeadCell>Link</Table.HeadCell>
								</Table.Head>
								<Table.Body>
									{recordings.map((r: any, i) => (
										<Table.Row key={i}>
											<Table.Cell>
												<div className="w-48 overflow-hidden text-ellipsis whitespace-nowrap">
													{r?.startTime ? moment(r.startTime).format('DD-MM-YYYY hh:mm a') : ''}
												</div>
											</Table.Cell>
											<Table.Cell>
												<div className="w-48 overflow-hidden text-ellipsis whitespace-nowrap">
													{r?.endTime ? moment(r.endTime).format('DD-MM-YYYY hh:mm a') : ''}
												</div>
											</Table.Cell>
											<Table.Cell>
												{r.status === RecordingStatus.INPROGRESS ? (
													<Badge className="w-max" color="warning">
														{r.status}
													</Badge>
												) : r.status === RecordingStatus.COMPLETED ? (
													<Badge className="w-max" color="success">
														{r.status}
													</Badge>
												) : r.status === RecordingStatus.UPLOADING ? (
													<Badge className="w-max" color="info">
														{r.status}
													</Badge>
												) : (
													<></>
												)}
											</Table.Cell>
											<Table.Cell>
												{r.fileName && (
													<Link
														data-testid={`interview-recordings-modal-link-download-${i}`}
														className="text-base text-[#7777E7]"
														target={'_blank'}
														to={r.fileName ?? ''}
													>
														<div className="w-48 overflow-hidden text-ellipsis whitespace-nowrap">Download</div>
													</Link>
												)}
											</Table.Cell>
										</Table.Row>
									))}
								</Table.Body>
							</Table>
						)}
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default MeetingRecordingModal;
